module.exports = __webpack_public_path__ + "static/L&G_overall-d65c2c1f214961f43cfc50b1912abd8c.jpg";